const languages = {
	en: 'English',
	fr: 'France',
	de: 'German',
	es: 'Spanish',
};

export default languages;
